<template>
   <div>
        <el-dialog
        title="请完善讲师基本信息"
        :visible.sync="value"
        :close-on-press-escape="false"
        width="600px"
        :show-close="false"
        center
        :close-on-click-modal="false"
        @close="close">
            <div class="teacher-info">
                <el-form :model="params" :rules="rules" ref="ruleForm" label-position="left" label-width="100px">
                     <el-form-item prop="avatar_url" label="讲师头像" style="disply:flex;">
                       <div class="basicInfo_user_img">
                           <div class="basicInfo_user_img_cons">
                                <el-image :src="params.avatar_url">
                                <div slot="error" class="image-slot" @click="editAvatarUrl">
                                    <i class="el-icon-plus"></i>
                                </div>
                            </el-image>
                            <div class="edit_img" v-show="params.avatar_url" @click="editAvatarUrl">
                                <span class="iconfont">&#xe605;</span>
                                <span>修改</span>
                            </div>
                           </div>
                           <div class="upload_img_suggest">建议尺寸150*150px</div>
                        </div>
                         
                    </el-form-item>
                    <el-form-item prop="name" label="讲师名称">
                        <el-input v-model="params.name" placeholder="请输入讲师名称限12字以内" maxlength="12"/>
                        <p style="font-size:12px;">限12字以内</p>
                    </el-form-item>
                    <el-form-item prop="desc" label="讲师介绍">
                        <el-input
					        type="textarea"
                            placeholder="请输入讲师介绍(在30-200字之间)"
                            :autosize="{ minRows: 4, maxRows: 6}"
                            v-model="params.desc"
                            minlength="30"
                            maxlength="200"
                            show-word-limit
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure">下一步</el-button>
            </div>
        </el-dialog>
        <uploader-img ref="uploaderImg" v-model="params.avatar_url" cropperW="240" cropperH="240" :ratio="[1,1]" :isAddSucaiFlag="false" :conFlag="false"></uploader-img>
   </div>
</template>
<script>
import uploaderImg from '@/components/upload/upload.vue'
import { mapActions } from 'vuex'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default: () => {
                return {
                    name: '',
                    avatar_url: '',
                    desc: ''
                }
            }
        }
    },
    components: {
        'uploader-img': uploaderImg
    },
    data() {
        return {
            rules: {
                avatar_url: [
                    { required: true, message: '请上传讲师头像', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入讲师名称', trigger: 'blur' },
                    { min: 0, max: 12, message: '讲师名称为12字以内', trigger: 'blur' }
                ],
                desc: [
                    { required: true, message: '请输入讲师介绍', trigger: 'blur' },
                    { min: 30, max: 200, message: '讲师介绍需在30-200字之间', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        ...mapActions('login', ['loginEditinfo']),
        close() {
            this.$emit('input', false)
        },
        editAvatarUrl() {
            this.$refs.uploaderImg.dialogVisible = true
        },
        sure() {
            this.$refs.ruleForm.validate(async (valid) => {
                if(valid) {
                    await this.loginEditinfo(this.params)
                    for (const key in this.params) {
                        this.$store.state.login.userInfo[key] = this.params[key]
                    }
                    this.$emit('input', false)
                    this.$emit('sure')
                }
            })
        }
    }
}
</script>
<style lang="less">
    .basicInfo_user_img {
        width:100%;
        height: 100px;
        margin-right: 20px;
        display: flex;
        .basicInfo_user_img_cons{
            display: block;
            width: 100px;
             height: 100px;
             overflow: hidden;
             position: relative;
             .el-image {
            display: block;
            width: 100px;
             height: 100px;
        }
        .image-slot {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f3f4f9;
            i {
                color: #c7cada;
                font-size: 18px;
            }
        }
        .edit_img {
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 100%;
            background-color: rgba(0,0,0,.5);
            height: 30px;
            color: #fff;
            z-index: 99;
            text-align: center;
            line-height: 30px;
            transition: .5s;
            font-size: 12px;
            transform: translateY(100%);
            cursor: pointer;
            .iconfont {
                margin-right: 2px;
            }
        }
        &:hover .edit_img {
            transform: translateY(0%);
        }
        }
        .upload_img_suggest{
            font-size: 12px;
            margin-left: 10px;
        }
       
    }
</style>
